<template>
    <div style="width:100%;text-align:center">
        
        <div  style="text-align:right;width: 100%;padding:10px;">
        <s-button v-if="isAdminSite"
            @onclick="setAdminSite"
            :label="$store.getters.getUser.adminSite ? 'ADMIN ON' : 'ADMIN OFF'"
            :theme="$store.getters.getUser.adminSite ? 'is-success' : 'is-warning'"
        />&nbsp;
       <s-button v-if="$store.getters.getUser.adminSite"
            @onclick="console"
            label="console"
            theme="is-primary"
        />
         <s-button v-if="$store.getters.getUser.adminSite"
            @onclick="stat"
            label="stat"
            theme="is-primary"
        />
        <s-button v-if="$store.getters.getUser.adminSite"
            @onclick="configEmails=!configEmails"
            :label="configEmails ? 'Retour' : 'Configurer les emails'"
            theme="is-primary"
        />
        <s-button v-if="$store.getters.getUser.adminSite"
            @onclick="configLabels=true"
            label="Configurer des label"
            theme="is-primary"
        />
         <div class="navbar-item">           
          <s-button theme="is-danger"   :disabled="isOffline" label="Se déconnecter" 
            icon="door-open" @onclick="logout"/>
        </div>

        </div>
        <div v-if="!configEmails">
        <input type="hidden" v-model="refresh"/>
        <div class="boxProfil">
            <profil-item :joueur="$store.getters.getUser" />
        </div>
       
        
            <div style="text-align:left">
                <div v-for="(club,key) in clubs" class="boxClub">
                    <profil-item :joueur="club" :club="key" />
                </div>
            </div>
        </div>
        <div v-if="configEmails">
            
            <admin-email/>
        </div>
        <s-modal
            :open="configLabels"
            :close="true"
            @close="configLabels=false"
            title="Configuration des labels"
        >
            <s-button @onclick="exportLabelsXLS" label="Exporter" icon="" theme="is-primary"/>
            <div>
                 <upload-excel-component 
                    :on-success="importLabelsXLS" 
                />
            </div>
        </s-modal>
    </div>
</template>
<style scoped>
    .boxProfil {
        width: 90%;
        margin: 10px;
    }
     .boxClub {
        width:90%;
        margin: 10px;
    }
</style>
<script>
import profilItem from "@/views/profil/profilItem.vue"
import adminEmail from "@/views/admin/configEmails.vue"
import firebase_api from "@/firebase/firebase_api"
import firebase from "firebase"
import UploadExcelComponent from '@/components/uploadXLS.vue'
import XLSX from 'xlsx'

export default {
    components: {
        profilItem,
        adminEmail,
        UploadExcelComponent
    },
    data() {
        return {
            clubs: {},
            refresh: false,
            configEmails: false,
            configLabels: false
        }
        
    },
    computed: {
        isAdminSite: {
            get() {
                return (typeof(this.$store.getters.getUser.adminSite)!="undefined")
            }
        }
    },
    methods: {
        console() {
             this.$router.push({name: "console"}).catch(error=>{});
        },
         stat() {
             this.$router.push({name: "stat"}).catch(error=>{});
        },
        setAdminSite() {
            var idUser = this.$store.getters.getUser.id;
            var adminSite = !this.$store.getters.getUser.adminSite;
            firebase_api.api.getDb().collection("user").doc(idUser).update({
                adminSite: adminSite
            })
        },
        logout() {
            firebase
                .auth()
                .signOut()
                .then(() => {
                this.$store.dispatch('init',()=>{
                    
                    this.$router.push({name: "home"}).catch(error=>{});
                });
            });
            },
        importLabelsXLS({ results, header }) {
      
            var labelJson = {}
            results.forEach(resultItem=>{
                labelJson[resultItem.id] = resultItem.value;
            })
            console.log(labelJson);
            
            firebase_api.api.getDb().collection("label").doc("fr").set(labelJson).then(
                alert("Mise à jour terminée")
            )
            
            
        },
       async exportLabelsXLS() {
           
            this.progress = true;
            
            var labelDoc = await firebase_api.api.getDb().collection("label").doc("fr").get()
            var labels = [];
            if (labelDoc.exists) {
                var labelData = labelDoc.data();
                for (var key in labelData) {
                    var labelItem = {}
                    labelItem.id = key;
                    labelItem.value = labelData[key]
                    labels.push(labelItem);
                }
            }
            var labelsXLS = XLSX.utils.json_to_sheet(labels)                
            var wb = XLSX.utils.book_new() // make Workbook of Excel

            // add Worksheet to Workbook
            // Workbook contains one or more worksheets
            XLSX.utils.book_append_sheet(wb, labelsXLS, 'labels') // sheetAName is name of Worksheet

            // export Excel file
            XLSX.writeFile(wb, "exportLabels.xlsx") // name of the file is 'book.xlsx'
            
        },
       
    },   
    mounted() {
        
       var clubs = {}
       if (typeof(this.$store.getters.getUser.clubs)!="undefined") {
           this.$store.getters.getUser.clubs.forEach(club=>{
            firebase_api.api.getDb().collection("club").doc(club.idClub).collection("joueurs").doc(club.idJoueur)
            .get().then(joueurDoc=>{
            if (joueurDoc.exists) {
                 this.refresh =  !this.refresh;
                 var joueurData = joueurDoc.data();
                 joueurData["idClub"] = club.idClub
                 this.clubs[club.nameClub] = joueurData;
                
            }
                
            })

        })
       }
        
        
    }
}
</script>